<template>
    <div class="popular">
        <header class="popular-panel__header h5">Populaire onderwerpen</header>
        <div class="popular-panel__grid">
            <a
                :href="item.Link.Url"
                :target="item.Link.Target"
                class="card"
                v-for="(item, index) in desktopNavStore.popularTopics"
                :key="`item-${index}`">
                <header class="card__header">{{ item.Link.Text }}</header>
                <div v-if="item.SubText" class="card__body">{{ item.SubText }}</div>
            </a>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useDesktopNavStore } from '../store/desktop-nav.store';

const desktopNavStore = useDesktopNavStore();
</script>
